import {createLazyFileRoute} from '@tanstack/react-router'

import Bookmark from '@/views/Bookmark/Bookmark'

export const Route = createLazyFileRoute('/bookmark')({
  component: Bookmark,
})
